export default "__VITE_ASSET__45e440e7__"